var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X-btn",
    transform: "translate(0.625 0.625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3331 26.6662C20.6968 26.6662 26.6662 20.6968 26.6662 13.3331C26.6662 5.96944 20.6968 0 13.3331 0C5.96944 0 0 5.96944 0 13.3331C0 20.6968 5.96944 26.6662 13.3331 26.6662Z",
    transform: "translate(0 0.06199483)",
    id: "Oval",
    fill: "#313131",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.9509L10.9509 0",
    transform: "translate(7.857653 7.919648)",
    id: "Line-12-Copy",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L10.9509 10.9509",
    transform: "translate(7.857653 7.919648)",
    id: "Line-12-Copy",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXBtn);
export default __webpack_public_path__ + "static/media/X-btn.813c83d2f4152ebae9c126bf2afa3a7c.svg";
export { ForwardRef as ReactComponent };